/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WorkshopsInputs */

const en__field_workshops = /** @type {(inputs: _Field_WorkshopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshops`)
};

const de__field_workshops = /** @type {(inputs: _Field_WorkshopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshops`)
};

/**
* | output |
* | --- |
* | "Workshops" |
*
* @param {_Field_WorkshopsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_workshops = /** @type {((inputs?: _Field_WorkshopsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WorkshopsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_workshops(inputs)
	return de__field_workshops(inputs)
});